import { defineComponent, getCurrentInstance, useCssModule } from '@nuxtjs/composition-api';
import { createHead, useAsyncRef } from '~/utils';
export default defineComponent({
    name: 'Participation',
    layout: 'rating-best-employers',
    setup() {
        const css = useCssModule();
        const instance = getCurrentInstance();
        const title = useAsyncRef(instance, 'title');
        return {
            css,
            title,
        };
    },
    async asyncData(context) {
        const { app, env, error, route } = context;
        try {
            const title = 'Участие в рейтинге 2025 года';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                head,
                title,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
